import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Doubles.scss";
import { addDoc, collection, getFirestore } from "firebase/firestore";

const shuffleArray = (array) => {
  return [...array].sort(() => Math.random() - 0.5);
};

const Doubles = () => {
  const location = useLocation();
  const { eventParticipantMember } = location.state || {};
  const initialPlayers = eventParticipantMember.split(",").map((s) => s.trim());
  const [isChecked, setIsChecked] = useState(false);

  // 状態としてシャッフル後のプレイヤーリストを管理
  const [players, setPlayers] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setPlayers(shuffleArray(initialPlayers));
  }, []);

  const shufflePlayers = () => {
    setPlayers(shuffleArray(initialPlayers));
  };

  // 指定の組み合わせリスト（1-indexed → 0-indexedに変換）
  //4人の場合
  const matchOrder4 = [
    [
      [1, 2],
      [3, 4],
    ],
    [
      [1, 3],
      [2, 4],
    ],
    [
      [1, 4],
      [2, 3],
    ],
  ].map((match) => match.map((pair) => pair.map((num) => num - 1))); // 0-indexed に変換

  //5人の場合
  const matchOrder5 = [
    [
      [1, 2],
      [3, 4],
    ],
    [
      [2, 3],
      [4, 5],
    ],
    [
      [1, 4],
      [3, 5],
    ],

    [
      [1, 5],
      [2, 4],
    ],

    [
      [1, 3],
      [2, 5],
    ],
    [
      [1, 4],
      [2, 3],
    ],
    [
      [2, 4],
      [3, 5],
    ],
    [
      [1, 5],
      [3, 4],
    ],
    [
      [1, 2],
      [4, 5],
    ],
    [
      [1, 3],
      [2, 5],
    ],
  ].map((match) => match.map((pair) => pair.map((num) => num - 1))); // 0-indexed に変換

  //6人の場合
  const matchOrder6 = [
    [
      [1, 2],
      [3, 4],
    ],
    [
      [1, 2],
      [5, 6],
    ],
    [
      [3, 4],
      [5, 6],
    ],
    [
      [1, 3],
      [2, 5],
    ],
    [
      [2, 5],
      [4, 6],
    ],
    [
      [1, 3],
      [4, 6],
    ],
    [
      [1, 4],
      [2, 6],
    ],
    [
      [1, 4],
      [3, 5],
    ],
    [
      [3, 5],
      [2, 6],
    ],
    [
      [1, 5],
      [4, 6],
    ],
    [
      [1, 5],
      [2, 3],
    ],
    [
      [2, 3],
      [4, 6],
    ],
  ].map((match) => match.map((pair) => pair.map((num) => num - 1))); // 0-indexed に変換

  //7人の場合
  const matchOrder7 = [
    [
      [1, 2],
      [3, 4],
    ],
    [
      [5, 6],
      [1, 7],
    ],
    [
      [2, 3],
      [4, 5],
    ],
    [
      [6, 2],
      [1, 7],
    ],
    [
      [6, 4],
      [3, 5],
    ],
    [
      [1, 3],
      [2, 7],
    ],
    [
      [4, 5],
      [6, 7],
    ],
    [
      [2, 4],
      [1, 5],
    ],
    // [
    //   [3, 4],
    //   [1, 5],
    // ],
    // [
    //   [2, 3],
    //   [4, 5],
    // ],
  ].map((match) => match.map((pair) => pair.map((num) => num - 1))); // 0-indexed に変換

  //8人の場合
  const matchOrder8 = [
    [
      [1, 2],
      [3, 4],
    ],
    [
      [5, 6],
      [7, 8],
    ],
    [
      [1, 5],
      [2, 6],
    ],
    [
      [3, 7],
      [4, 8],
    ],
    [
      [1, 6],
      [3, 8],
    ],
    [
      [2, 5],
      [4, 7],
    ],
    [
      [1, 3],
      [5, 7],
    ],
    [
      [2, 4],
      [6, 8],
    ],
    // [
    //   [3, 4],
    //   [1, 5],
    // ],
    // [
    //   [2, 3],
    //   [4, 5],
    // ],
  ].map((match) => match.map((pair) => pair.map((num) => num - 1))); // 0-indexed に変換

  // console.log("initialPlayers:", initialPlayers);
  let matchOrder = matchOrder4;
  switch (initialPlayers.length) {
    case 4:
      matchOrder = matchOrder4;
      break;
    case 5:
      matchOrder = matchOrder5;
      break;
    case 6:
      matchOrder = matchOrder6;
      break;
    case 7:
      matchOrder = matchOrder7;
      break;
    case 8:
      matchOrder = matchOrder8;
      break;
    default:
      alert("対応する人数の乱数表は作成しておりません");
  }

  const [resultmatch, setResultMatch] = useState(
    matchOrder.map(() => ({ win: [] }))
  );

  // ページがロードされたときに一度だけシャッフルする
  useEffect(() => {
    const shuffled = [...initialPlayers].sort(() => Math.random() - 0.5);
    setPlayers(shuffled);
  }, []);

  const [checkedItems, setCheckedItems] = useState(
    Array(matchOrder.length).fill(false)
  );
  const [checkedItems2, setCheckedItems2] = useState(
    Array(matchOrder.length).fill(false)
  );

  const handleCheckboxChange = (index, pair1, pair2) => {
    const updatedCheckedItems = [...checkedItems];
    const updatedCheckedItems2 = [...checkedItems2];

    updatedCheckedItems[index] = !updatedCheckedItems[index];
    updatedCheckedItems2[index] = false; // 片方のチェックが入ると、もう片方は外れる

    // `resultmatch` を更新
    setResultMatch((prevResultMatch) => {
      const newResultMatch = [...prevResultMatch];
      newResultMatch[index] = {
        ...newResultMatch[index],
        win: updatedCheckedItems[index] ? [pair1, pair2] : [],
      };
      return newResultMatch;
    });

    setCheckedItems(updatedCheckedItems);
    setCheckedItems2(updatedCheckedItems2);
  };

  const handleCheckboxChange2 = (index, pair1, pair2) => {
    const updatedCheckedItems = [...checkedItems];
    const updatedCheckedItems2 = [...checkedItems2];

    updatedCheckedItems2[index] = !updatedCheckedItems2[index];
    updatedCheckedItems[index] = false; // 片方のチェックが入ると、もう片方は外れる

    // `resultmatch` を更新
    setResultMatch((prevResultMatch) => {
      const newResultMatch = [...prevResultMatch];
      newResultMatch[index] = {
        ...newResultMatch[index],
        win: updatedCheckedItems2[index] ? [pair1, pair2] : [],
      };
      return newResultMatch;
    });

    setCheckedItems(updatedCheckedItems);
    setCheckedItems2(updatedCheckedItems2);
  };

  // ✅ これで正しく win データが反映される
  // console.log(resultmatch);
  const winCounts = {};
  resultmatch.forEach((match) => {
    match.win.forEach((player) => {
      winCounts[player] = (winCounts[player] || 0) + 1;
    });
  });

  // オブジェクトを降順に並び替えた配列に変換
  const sortedWinArray = Object.entries(winCounts)
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count);

  // console.log(sortedWinArray);

  //参加した試合数を集計
  //全試合のデータ
  const matchesWithWin = resultmatch.filter(
    (match) => match.win && match.win.length > 0
  );

  console.log(matchesWithWin);

  const db = getFirestore();

  // 新しいコレクションの参照を取得
  const collectionRef = collection(db, "sortedWinsCollection");
  const saveSortedWinArray = async () => {
    try {
      // addDoc を使用して新しいドキュメントを追加
      const docRef = await addDoc(collectionRef, {
        sortedWins: sortedWinArray,
      });
      console.log("Document written with ID: ", docRef.id);
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return (
    <div className="doubles_container">
      <div className="doubles_content">
        <h2>
          <span className="doubles_text">ダブルス組み合わせ表</span>
        </h2>
        <h3>
          <span className="doubles_text">参加者リスト</span>
        </h3>
        <p>
          <span className="doubles_text">
            {players.length > 0 ? players.join(" / ") : "Loading..."}
          </span>
        </p>
        <div className="doubles_button">
          <button
            className="doubles_reshufle"
            onClick={shufflePlayers}
            style={{ marginBottom: "10px" }}
          >
            再シャッフル
          </button>
          <button
            className="doubles_resultsave"
            onClick={saveSortedWinArray}
            style={{ marginBottom: "10px" }}
          >
            勝利数集計保存
          </button>
        </div>

        <table
          className="doubles_table"
          border="1"
          cellPadding="5"
          style={{ borderCollapse: "collapse", marginTop: "10px" }}
        >
          <thead>
            <tr>
              <th>
                <span className="doubles_text">NO.</span>
              </th>
              <th>
                <span className="doubles_text">win</span>
              </th>
              <th>
                <span className="doubles_text">ペア1</span>
              </th>
              <th>
                <span className="doubles_text">ペア2</span>
              </th>
              <th>
                <span className="doubles_text">win</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {players.length > 0 &&
              matchOrder.map((match, index) => (
                <tr key={index}>
                  <td>
                    <span className="doubles_text">{index + 1}</span>
                  </td>

                  <td>
                    <input
                      type="checkbox"
                      className="doubles_text_checkbox1"
                      name="scales"
                      checked={checkedItems[index]}
                      onChange={() =>
                        handleCheckboxChange(
                          index,
                          players[match[0][0]],
                          players[match[0][1]]
                        )
                      }
                    />
                  </td>
                  <td>
                    <span className="doubles_text">
                      {players[match[0][0]]} & {players[match[0][1]]}
                    </span>
                  </td>
                  <td>
                    <span className="doubles_text">
                      {players[match[1][0]]} & {players[match[1][1]]}
                    </span>
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      className="doubles_text_checkbox2"
                      name="scales"
                      checked={checkedItems2[index] || false}
                      onChange={() =>
                        handleCheckboxChange2(
                          index,
                          players[match[1][0]],
                          players[match[1][1]]
                        )
                      }
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th>
                <span className="doubles_text">順位</span>
              </th>
              <th>
                <span className="doubles_text">名前</span>
              </th>
              <th>
                <span className="doubles_text">勝利数</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedWinArray
              .reduce((acc, item, index, arr) => {
                // 前の順位を取得
                const prev = arr[index - 1];

                // 順位の計算（同じ勝利数なら同じ順位）
                const rank =
                  index > 0 && prev.count === item.count
                    ? acc[acc.length - 1].rank
                    : index + 1;

                // 配列に追加
                acc.push({ ...item, rank });
                return acc;
              }, [])
              .map((item, index) => (
                <tr key={index}>
                  <td>
                    <span className="doubles_text">{item.rank}</span>
                  </td>{" "}
                  {/* ランキングの順位 */}
                  <td>
                    <span className="doubles_text">{item.name} </span>
                  </td>{" "}
                  {/* 勝者の名前 */}
                  <td>
                    <span className="doubles_text">{item.count}</span>
                  </td>{" "}
                  {/* 勝利数 */}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Doubles;
